import ContentModel from "../../content/_model/ContentModel";
import EntityListModel from "../../entity/_model/EntityListModel";

class ContentListModel extends EntityListModel<ContentModel> {}

export default ContentListModel;
